import { useQuery } from 'react-query';
import { apiService } from '../../../utils/api';

const useGetDocument = (id) => {
  return useQuery({
    queryKey: ['document', id],
    enabled: !!id,
    queryFn: async () => {
      const { data } = await apiService.get(`/api/v1/document/${id}/`);
      return data;
    },
    refetchOnWindowFocus: false,
  });
};

export default useGetDocument;
